import { EventBase } from "@vp/models";
import { IFileUpload } from "../file";

export class UploadCompletedEvent extends EventBase<IFileUpload> {
  constructor(private fileSelection: IFileUpload) {
    super();
    this.args = this.fileSelection;
  }
}
